import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-auto-close-dialog',
  templateUrl: './auto-close-dialog.component.html',
  styleUrls: ['./auto-close-dialog.component.scss']
})
export class AutoCloseDialogComponent implements OnInit {

  message: string = '';
  showUndo: boolean = false;
  showClose: boolean = true;
  autoClose: boolean = true;      
  timeInSeconds: number = 10;
  ctaText = 'Undo'      
  private timerRef: any;

  constructor(
    public dialogRef: MatDialogRef<AutoCloseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.message = data.message || '';
      this.autoClose = data.autoClose ?? true;
      this.timeInSeconds = data.timeInSeconds || 10;
      this.showUndo = data.showUndo
      this.ctaText = data.ctaText || this.ctaText
    }
  }

  ngOnInit(): void {
   
    if (!this.message.trim()) {
      console.error(' Message is mandatory for AutoCloseDialogComponent.');
      this.dialogRef.close();
      return;
    }

    
    if (!this.autoClose) {
      this.timerRef = setTimeout(() => {
        this.close();
      }, this.timeInSeconds * 1000);
    }
  }

  close(): void {
    if (this.timerRef) clearTimeout(this.timerRef);
    this.dialogRef.close();
  }

  undo(): void {
    if (this.timerRef) clearTimeout(this.timerRef);
    this.dialogRef.close(this.ctaText || 'undo');
  }
}
